/* clone-rv-footer: popover "Terms and Policies" (hover hoặc bấm để mở) */
if (!customElements.get('rv-footer-policies')) {
  class RvFooterPolicies extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.rv-footer-policies__trigger');
      if (!this.trigger) return;
      this.onClick = () => this.toggle(!this.classList.contains('is-open'));
      this.onDocClick = (event) => {
        if (!this.contains(event.target)) this.toggle(false);
      };
      this.onKeyup = (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.toggle(false);
          this.trigger.focus();
        }
      };
      this.trigger.addEventListener('click', this.onClick);
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keyup', this.onKeyup);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keyup', this.onKeyup);
    }

    toggle(open) {
      this.classList.toggle('is-open', open);
      this.trigger.setAttribute('aria-expanded', String(open));
    }
  }

  customElements.define('rv-footer-policies', RvFooterPolicies);
}
